import p1 from "../partition/p1.jpeg"
import p2 from "../partition/p2.jpeg"
import p3 from "../partition/p3.jpeg"
import p4 from "../partition/p4.jpeg"
import p5 from "../partition/p5.jpeg"
import p6 from "../partition/p6.jpeg"
import p7 from "../partition/p7.jpeg"
import p8 from "../partition/p8.jpeg"
import p9 from "../partition/p9.jpeg"




function Partition() {
  return (

    <div class="container">
      <h1>Partitions Work</h1>
      <h4>Built with care, delivered with pride — a few of our works.</h4>

      <div class="row row-cols-1 row-cols-sm-2 row-cols-md-3 g-3">
        <div class="col">
          <div class="card shadow-sm">
            <img src={p1} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p2} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p3} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p4} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p5} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p6} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p7} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p8} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
        <div class="col">
          <div class="card shadow-sm">
            <img src={p9} className="card-img-top" alt="Thumbnail" style={{ height: "225px", objectFit: "cover" }} />
          </div>
        </div>
      </div>
      <p><a class="btn btn-success" href="https://www.instagram.com/invites/contact/?igsh=1izl3bvvj2uj3&utm_content=zvshzkp">View more &raquo;</a></p>
      <hr class="featurette-divider" /></div>

  );
}

export default Partition;
